<template>
  <a
    :class="{
      notliked: !mutableLike,
      [notLikedColor]: !mutableLike,
      liked: mutableLike,
      [likedColor]: mutableLike,
    }"
    :title="
      $t(
        mutableLike
          ? isTypeJob
            ? 'Click to remove from saved jobs'
            : 'Click to remove from saved profiles'
          : isTypeJob
          ? 'Click to add to saved jobs'
          : 'Click to add to saved profiles',
      )
    "
    class="f-20 iblock"
    href="#"
    @click="toggleLike"
  >
    <span aria-hidden="true" class="glyphicon glyphicon-heart" />
  </a>
</template>

<script>
import enums from '@/utils/enum'
import { jobs, users } from '@/api/vue-api'

export default {
  name: 'ProfileLikeVue',
  props: {
    liked: {
      type: Boolean,
      required: false,
      default: false,
    },
    cardId: {
      type: [String, Number], // Since we start using global ids we might get them in string versions
      required: true,
    },
    cardType: {
      type: String,
      required: true,
    },
    notLikedColor: {
      type: String,
      required: false,
      default: 'c-gray',
    },
    likedColor: {
      type: String,
      required: false,
      default: 'c-orange-500',
    },
  },
  data() {
    return {
      updatingLike: false,
      mutableLike: false,
      lastAction: null,
    }
  },
  computed: {
    isTypeJob() {
      if (enums.cards.types.indexOf(this.cardType) === -1) {
        throw new Error(`Card Type: ${this.cardType} is not a recognized type`)
      }
      return this.cardType === enums.cards.job
    },
  },
  created() {
    this.mutableLike = this.liked
  },
  methods: {
    async toggleLike() {
      if (this.updatingLike) return
      this.mutableLike = !this.mutableLike
      if (this.lastAction === this.mutableLike) {
        return
      }
      this.updatingLike = true
      try {
        this.lastAction = this.mutableLike
        if (this.isTypeJob) {
          await jobs.likeJob(this.cardId, this.mutableLike)
        } else {
          // Should be moved into an account like at some point
          await users.likeUser(this.cardId, this.mutableLike)
        }
        this.updatingLike = false
      } catch (e) {
        this.updatingLike = false
        this.$store.commit('sendNotification', {
          type: enums.notification.types.ERROR,
          msg: this.$t(`An error occurred when trying to ${this.mutableLike ? 'like' : 'unlike'}`),
          sender: this,
          severity: enums.notification.severity.CRITICAL,
        })
        this.mutableLike = !this.mutableLike
      }
    },
  },
}
</script>

<style scoped></style>
